import { rankWith, isControl } from '@jsonforms/core';
import type {
  UISchemaElement,
  JsonSchema,
  TesterContext,
} from '@jsonforms/core';

export const multiSelectTester = rankWith(
  4,
  (uischema: UISchemaElement, schema: JsonSchema, context: TesterContext) => {
    if (!isControl(uischema)) {
      return false;
    }

    if (!context?.rootSchema?.properties) {
      return false;
    }

    const path = uischema.scope;
    const propertyName = path.split('/').pop() ?? '';

    if (!propertyName) {
      return false;
    }

    const propertySchema = context.rootSchema.properties[propertyName];

    if (!propertySchema) {
      return false;
    }

    const hasWidget = (propertySchema as any)?.['x-widget'] === 'multi-select';

    return hasWidget;
  }
);
